require('intersection-observer')

import appUtils from './app_utils'
import utils from './utils'

import { fontAnimationAdd } from './animations'

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const dataAttrSuffix = 'fontanimation'
const dataAttr = 'data-' + dataAttrSuffix
let instances = []


class Title {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.titleTimeline = null



    this.titleTimeline = gsap.timeline({
      delay: 2,
      scrollTrigger: {
        trigger: this.$title,
        start: "top 60%",
        // once: true,
        toggleActions: 'play none play reverse',
      }
    })

    fontAnimationAdd(this.titleTimeline, this.$el, 0, '>', 0, false)
    //this.titleTimeline.from(this.$el.find('.t'), { opacity: 0, y: 30, stagger: 0.2, duration: 1 }, '>-=0.6')
  }

  destroy() {
    if (this.titleTimeline) {
      this.titleTimeline.scrollTrigger.kill()
      this.titleTimeline.kill()
    }
  }
}





const init = function() {
  //if(appUtils.isTouch()){
  $('[' + dataAttr + ']').each(function(index) {
    const spInstance = new Title(this, {index: index})
    instances.push(spInstance)
  })
}

const destroy = function() {
  //if(appUtils.isTouch()){
  instances.forEach(spInstance => {
    spInstance.destroy()
  })
  instances = []
}

export default {init, destroy}
